export enum UnitFamily {
  USCustomary,
  Metric
}

export const UnitFamilyMap = new Map<number, string>([
  [UnitFamily.Metric, 'Metric'],
  [UnitFamily.USCustomary, 'United States Customary']
]);

export const UnitFamilyTypeMap = new Map<UnitFamily, any>([
  [UnitFamily.Metric, {
    abbrev: {
      wallThickness: 'Units.US.Abbrev.Mil',
      diameter: 'Units.Metric.Abbrev.Millimeter',
      length: 'Units.Metric.Abbrev.Meter',
      spacing: 'Units.Metric.Abbrev.Centimeter',
      flow: 'Units.Metric.Abbrev.LitersPerHour',
      flowLarge: 'Units.Metric.Abbrev.LitersPerHour',
      flowPerArea: 'Units.Metric.Abbrev.LPHPerHectare',
      lengthPerArea: 'Units.Metric.Abbrev.MeterPerHectare',
      pressure: 'Units.Metric.Abbrev.Bar',
      velocity: 'Units.Metric.Abbrev.MeterPerSecond',
      area: 'Units.Metric.Hectare',
      distance: 'Units.Metric.Abbrev.Distance',
      pressureLarge: 'Units.Metric.Abbrev.Bar',
      pressureSmall: 'Units.Metric.Abbrev.Pascal',
      elevation: 'Units.Metric.Abbrev.Elevation',
    },
    diameter: 'Units.US.Inch',
    length: 'Units.US.Foot',
    spacing: 'Units.US.Spacing',
    flow: 'Units.Metric.LitersPerHour',
    pressure: 'Units.Metric.Pressure',
    velocity: 'Units.Metric.MeterPerSecond',
    area: 'Units.Metric.Hectare',
    distance: 'Units.Metric.Meter',
    emitterFlow: 'Units.Metric.EmitterFlow',
    headLoss: 'Units.Metric.HeadLoss',
    LateralFlow: 'Units.Metric.LateralFlow',
    EmitterFlow: 'Units.Metric.EmitterFlow',
    AverageFlow: 'Units.Metric.AverageFlow',
    BlockFlow: 'Units.Metric.BlockFlow',
    PrecipitationRate: 'Units.Metric.MillimeterPerHour',
    elevation: 'Units.Metric.Elevation',
  }],
  [UnitFamily.USCustomary, {
    abbrev: {
      wallThickness: 'Units.US.Abbrev.Mil',
      distance: 'Units.US.Abbrev.Foot',
      distances: 'Units.US.Abbrev.Feet',
      diameter: 'Units.US.Abbrev.Inch',
      length: 'Units.US.Abbrev.Foot',
      lengthPerArea: 'Units.US.Abbrev.FeetPerAcre',
      spacing: 'Units.US.Abbrev.Spacing',
      flow: 'Units.US.Abbrev.GallonsPerMinute',
      flowLarge: 'Units.US.Abbrev.GallonsPerHour',
      flowPerArea: 'Units.US.Abbrev.GPMPerAcre',
      pressure: 'Units.US.Abbrev.Pressure',
      velocity: 'Units.US.Abbrev.Velocity',
      area: 'Units.US.Abbrev.Acre',
      elevation: 'Units.US.Abbrev.Elevation',
    },
    diameter: 'Units.US.Inch',
    length: 'Units.US.Foot',
    spacing: 'Units.US.Spacing',
    flow: 'Units.US.GallonsPerMinute',
    pressure: 'Units.US.Pressure',
    velocity: 'Units.US.',
    area: 'Units.US.Acres',
    elevation: 'Units.US.Elevation',

    distance: 'Units.US.Foot',
    distances: 'Units.US.Feet',
    emitterFlow: 'Units.US.EmitterFlow',
    headLoss: 'Units.US.HeadLoss',
    BlockFlow: 'Units.US.BlockFlow',
    LateralFlow: 'Units.US.LateralFlow',
    EmitterFlow: 'Units.US.EmitterFlow',
    AverageFlow: 'Units.US.AverageFlow',
    PrecipitationRate: 'Units.US.InchPerHour',
  }]
])
